import { useState } from "react";
import PageHeader from "@/components/shared/PageHeader";
import LoadingSkeleton from "@/components/shared/LoadingSkeleton";
import ErrorState from "@/components/shared/ErrorState";
import EmptyState from "@/components/shared/EmptyState";
import { useTerritorialInspections } from "@/hooks";
import type { TerritorialInspectionSummary } from "@/types/territorial-inspection";
import PreliminaryDataBanner from "./components/PreliminaryDataBanner";
import ImportJsonPanel from "./components/ImportJsonPanel";
import InspectionsTable from "./components/InspectionsTable";
import InspectionDetailDrawer from "./components/InspectionDetailDrawer";

export default function TerritorioInspecoesPage() {
  const { inspections, loading, error } = useTerritorialInspections();
  const [selected, setSelected] = useState<TerritorialInspectionSummary | null>(null);

  return (
    <div className="space-y-5">
      <PageHeader
        title="Território > Inspeções"
        subtitle="Inspeções territoriais assistidas por IA (metodologia FloraIQ FITA v1.0) — análises visuais preliminares por quadra do Setor Bela Vista."
      />

      <PreliminaryDataBanner />

      <ImportJsonPanel />

      {loading && <LoadingSkeleton type="table" count={5} />}

      {!loading && error && <ErrorState message="Não foi possível carregar as inspeções territoriais." />}

      {!loading && !error && inspections.length === 0 && (
        <EmptyState
          icon="ri-image-add-line"
          title="Nenhuma inspeção territorial importada ainda"
          description="Envie uma ortoimagem ao Analista Territorial IA (ChatGPT), gere o JSON conforme o contrato FITA v1.0 e importe via POST /api/v1/territorial-inspections/import-json para ver as inspeções aqui."
        />
      )}

      {!loading && !error && inspections.length > 0 && (
        <>
          <p className="text-xs text-foreground-500">{inspections.length} inspeções territoriais encontradas</p>
          <InspectionsTable inspections={inspections} onOpen={setSelected} />
        </>
      )}

      <InspectionDetailDrawer
        inspectionCode={selected?.inspectionCode ?? null}
        onClose={() => setSelected(null)}
      />
    </div>
  );
}
